<template>
  <p class="lead pre-line">{{attachment.comment}}</p>
</template>

<script>
  export default {
    props: {
      attachment: {
        type: Object,
        default: function () {
          return {};
        }
      }
    }
  }
</script>